export { ModalBackdropComponent, ModalBackdropOptions } from './modalBackdrop.component';
export { ModalOptions, MDBModalRef } from './modal.options';
export { ModalDirective } from './modal.directive';
export { ModalModule } from './modal.module';
export { MDBModalService } from './modal.service';
export { ModalContainerComponent } from './modalContainer.component';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/~/angular-bootstrap-md/modals/index.js
// module id = ../../../../angular-bootstrap-md/modals/index.js
// module chunks = 3